module.exports = __webpack_public_path__ + "static/media/success.06ba66ec.svg";